<div class="container">
  <div class="header-contents header-margin">
    <div class="filters-section">
      <app-custom-date-select
        [(ngModel)]="selectedDate"
        class="date-select"
        [minDate]="minDate"
        [maxDate]="maxDate"
        selectionMode="month-year"
        (dateChange)="onDateSelected($event)"
      />
    </div>
    <div class="export-container">
      <img
        class="export-icon"
        src="/assets/images/pdf.svg"
        (click)="openPopup('pdf')"
        alt="export to pdf"
        title="Export to PDF"
      />
    </div>
  </div>
  <div class="mat-container">
    <div id="status-content">
      <div class="status-card">
        <div class="status">
          <p class="status-text">Current Participation Status</p>
          <p class="status-value">{{ statementParticipation }}</p>
        </div>

        <div class="details">
          <p>
            Group Code:
            <b>{{ selectedDealer?.groupMemberCode?.slice(0, -2) }}</b>
          </p>
          <p>
            Processing Date Month: <b>{{ processingMonthYear }}</b>
          </p>
          <p>
            Today's Date: <b>{{ currentDate }}</b>
          </p>
        </div>
      </div>
    </div>
    @if (showErrorPage) {
      <div class="error-row">
        <app-error-page [statusCode]="statusCode" />
      </div>
    } @else {
      <div class="table-container" id="pdf-table-content">
        <table class="table">
          <thead class="table-head">
            <tr class="header-row pdf-print-row">
              <th class="header" rowspan="2">Member#</th>
              <th class="header" rowspan="2">Statement Data Received Date</th>
              <th class="header" rowspan="2">Input Sheet Data Received Date</th>
              <th class="header" colspan="2">Date Data Uploaded</th>
              <th class="header" rowspan="2">Source</th>
            </tr>
            <tr class="header-row pdf-print-row">
              <th class="header">First</th>
              <th class="header">Final</th>
            </tr>
          </thead>

          <tbody class="table-body">
            @if (isSpinner) {
              <tr>
                <td colspan="6">
                  <div class="spinner-row">
                    <div class="table-spinner">
                      <app-nada-spinner />
                    </div>
                  </div>
                </td>
              </tr>
            } @else if (participationGrid.length > 0) {
              @for (member of participationGrid; track member) {
                <tr class="data-row pdf-print-row">
                  <td class="table-data">{{ member.Member_Number }}</td>
                  <td class="table-data">
                    {{ member.Statement_Data_Received_Day }}
                  </td>
                  <td class="table-data">
                    {{ member.Input_Sheet_Data_Received_Day }}
                  </td>
                  <td class="table-data">
                    {{ member.Date_Data_Uploaded_Day_First }}
                  </td>
                  <td class="table-data">
                    {{ member.Date_Data_Uploaded_Day_Final }}
                  </td>
                  <td class="table-data">{{ member.Source }}</td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>

@if (showExcelPdfPopUp) {
  <!-- Popup Component -->
  <app-excelpdfpopup
    #pdfExcelPopup
    [mode]="mode"
    [title]="popupTitle"
    [reportTitle]="reportTitle"
    [options]="pdfOptions"
    [isPageLayoutEnabled]="isPageLayoutEnabled"
    (closeClicked)="closePopup()"
    (primaryButtonClicked)="handlePrimaryButtonClick($event)"
  >
  </app-excelpdfpopup>
}

@if (showErrorModal) {
  <app-popup [showHeader]="false">
    <div class="error-image">
      <img src="/assets/images/error-icon.svg" alt="error image" />
    </div>
    <div class="response-content">
      <p class="response-title">Error</p>
      <p class="response-text">{{ errorMessage }}</p>
      <button class="response-cta" (click)="showErrorModal = false">Ok</button>
    </div>
  </app-popup>
}
@if (showSuccessModal) {
  <app-popup [showHeader]="false">
    <div class="success-image">
      <img src="/assets/images/success-icon.svg" alt="success image" />
    </div>
    <div class="response-content">
      <p class="response-title">Success!</p>
      <p class="response-text">{{ successMessage }}</p>
      <button class="response-cta" (click)="showSuccessModal = false">
        Ok
      </button>
    </div>
  </app-popup>
}
@if (showPdfExportMessage) {
  <app-popup
    title="PDF Export"
    primaryButtonText="Close"
    [showClose]="true"
    (primaryButtonClicked)="showPdfExportMessage = false"
    (closeClicked)="showPdfExportMessage = false"
  >
    <p class="pdf-text">
      {{ pdfExportMessage }}
    </p>
    <p class="pdf-link" (click)="onShowPdf()">View PDF</p>
  </app-popup>
}

<div
  id="pdf-render-host"
  style="
    position: fixed;
    left: -10000px;
    top: 0;
    width: 1200px;
    pointer-events: none;
    visibility: hidden;
  "
></div>
